"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Empty = function () {
    function Empty() {
        _classCallCheck(this, Empty);
    }

    _createClass(Empty, [{
        key: "listenBreakpoint",
        value: function listenBreakpoint() {}
    }, {
        key: "unlistenBreakpoint",
        value: function unlistenBreakpoint() {}
    }]);

    return Empty;
}();

exports.default = Empty;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fluid-react/dist/media/Empty.js
 ** module id = 772
 ** module chunks = 0
 **/